import { dateInPast } from "utils/date_utils"
import jwtDecode from "jwt-decode"
import { logout } from 'data/auth'

const jwt = ({ getState, dispatch }) => {
  return (next) => (action) => {
    const auth = !!action.auth

    if (!auth) return next(action)

    const token = localStorage.getItem("token")

    if (token) {
      const expiresAt = (jwtDecode(token)).exp

      if (!dateInPast(+expiresAt * 1000)) {
        return next(action)
      } else {
        dispatch(logout())
      }
    }
  }
}

export default jwt


// WEBPACK FOOTER //
// src/data/jwt/index.js